import { render, staticRenderFns } from "./IconCheck.vue?vue&type=template&id=37b63d90&scoped=true&"
import script from "./IconCheck.vue?vue&type=script&lang=js&"
export * from "./IconCheck.vue?vue&type=script&lang=js&"
import style0 from "./IconCheck.vue?vue&type=style&index=0&id=37b63d90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b63d90",
  null
  
)

export default component.exports